export default __webpack_public_path__ + "static/media/jackets.638d3008.svg";